import { useTranslation } from 'react-i18next';
import { Fragment, useMemo } from 'react';

import _ from 'lodash';

import { useFlightTicketRequests } from 'entities/Flights/sdk';

import Navigation from 'components/Navigation';
import PageContent from 'components/PageContent';
import PageTitle from 'components/PageTitle';
import FlightBox from 'pages/Flights/FlightBox';
import Title from 'pages/Flights/Title';
import { FlightTicketProposalStatusEnum } from 'utils/constants';
import Footer from 'components/Footer';
import Loader from 'components/Loader';

const Flights = () => {
  const { t } = useTranslation();
  const { data: flightTicketRequests, isLoading } = useFlightTicketRequests();

  const upcomingFlights = useMemo(
    () =>
      _.filter(
        flightTicketRequests,
        (flightTicketRequest) => flightTicketRequest.computed_status !== FlightTicketProposalStatusEnum.OPERATED
      ),
    [flightTicketRequests]
  );

  const pastFlights = useMemo(
    () =>
      _.filter(
        flightTicketRequests,
        (flightTicketRequest) => flightTicketRequest.computed_status === FlightTicketProposalStatusEnum.OPERATED
      ),
    [flightTicketRequests]
  );

  return (
    <Fragment>
      <Navigation />
      <PageContent>
        <PageTitle text={t('flights.title')} />
        {isLoading ? (
          <div className='flex flex-1 items-center justify-center h-full'>
            <Loader className='size-20 text-primary' />
          </div>
        ) : (
          <div className='pt-[28px] flex flex-col gap-[8px]'>
            <Title text={t('flights.upcoming')} />
            <div className='flex flex-row gap-6 max-sm:flex-col flex-wrap'>
              {_.map(upcomingFlights, (flightTicketRequest, index) => (
                <FlightBox key={index} flightTicketRequest={flightTicketRequest} />
              ))}
            </div>

            {!_.isEmpty(pastFlights) && (
              <Fragment>
                <Title text={t('flights.past')} />{' '}
                <div className='flex flex-row gap-6 max-lg:flex-col'>
                  {_.map(pastFlights, (flightTicketRequest) => (
                    <FlightBox flightTicketRequest={flightTicketRequest} />
                  ))}
                </div>
              </Fragment>
            )}
          </div>
        )}
      </PageContent>
      <Footer />
    </Fragment>
  );
};

export default Flights;
